module.exports = __webpack_public_path__ + "static/media/slide-2.cb75fcc8.jpg";